(function () {
  const TITLE_SELECTOR = '[data-challenge-fit-text]';
  const MIN_FONT_SIZE = 16;
  const STEP = 1;

  const fitTitle = (title) => {
    if (!title) return;

    const computedStyle = window.getComputedStyle(title);
    const maxFontSize = parseFloat(title.dataset.maxFontSize || computedStyle.fontSize);
    const minFontSize = parseFloat(title.dataset.minFontSize || MIN_FONT_SIZE);

    if (!maxFontSize || !Number.isFinite(maxFontSize)) return;

    title.style.fontSize = `${maxFontSize}px`;

    let nextFontSize = maxFontSize;

    while (title.scrollWidth > title.clientWidth && nextFontSize > minFontSize) {
      nextFontSize -= STEP;
      title.style.fontSize = `${nextFontSize}px`;
    }
  };

  const fitAllTitles = (container = document) => {
    container.querySelectorAll(TITLE_SELECTOR).forEach((title) => fitTitle(title));
  };

  const observeTitles = (container = document) => {
    if (!('ResizeObserver' in window)) return;

    container.querySelectorAll(TITLE_SELECTOR).forEach((title) => {
      if (title._challengeFitTextObserver) return;

      const observer = new ResizeObserver(() => fitTitle(title));
      observer.observe(title);
      title._challengeFitTextObserver = observer;
    });
  };

  const init = (container = document) => {
    fitAllTitles(container);
    observeTitles(container);
  };

  if (window.ChallengeWeekMenuFitText) {
    window.ChallengeWeekMenuFitText.init(document);
    return;
  }

  window.ChallengeWeekMenuFitText = {
    init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  window.addEventListener('load', () => fitAllTitles(document), { once: true });
  window.addEventListener('resize', () => fitAllTitles(document));

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
